import React, { useRef, useState, useEffect } from 'react';
import Layout from '../layout/layout';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Container,
  CardHeader,
  IconButton,
  Divider,
  CardActions,
  FormHelperText,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import {
  FloatingButton,
  MinimalTextField,
  MinimalTextArea,
  MinimalSingleSelect,
} from '../common/form-control';
import ENUMS from '../../constants/enum';
import {
  addBadge,
  getBadgeById,
  updateBadge,
  getBadgesCategory,
} from '../../services/badge-service';
import { Toast } from '../common/toast-utils';
import BadgesIcon from '../../assets/icons/badges';
import { RingSpinnerOverlay } from 'react-spinner-overlay';
import { BadgesLanguageContentCard } from './BadgesLanguageContentCard';
import { ArrowBack, CloudUpload } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { DialogPrompt } from '../common/other-component';
import { isValidFileType } from '../../helpers/common-helper';
import { AddIcon, DeleteIcon } from '../../assets/icons/icons';
import getUserRole from '../../helpers/getuser-role';
import * as yup from 'yup';
import { validateSchema } from '../../helpers/schema-validation';

const flagMap = {
  deFlag: require('../../assets/images/ge_flag.png'),
  duFlag: require('../../assets/images/du_flag.png'),
  enFlag: require('../../assets/images/en_flag.png'),
};

const LANGUAGES = ENUMS.BADGE_LANGUAGES.map((lang) => ({
  ...lang,
  flag: flagMap[lang.flag],
}));

const initialForm = LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = { name: '', description: '' };
  return acc;
}, {});

const filterSchema = yup.array().of(
  yup.object().shape({
    andOr: yup.string().test('andOr-required', 'Required', function (value) {
      if (this.options.index > 0) {
        return !!value;
      }
      return true;
    }),
    parameter: yup.string().required('Required'),
    value: yup.string().required('Required'),
    operator: yup.string().test('value-required', 'Required', function (value) {
      const { parameter } = this.parent;
      if (parameter !== 'Workouts') {
        return !!value;
      }
      return true; // Optional for Workouts
    }),
    unit: yup.string().test('value-required', 'Required', function (value) {
      const { parameter } = this.parent;
      if (parameter !== 'Workouts') {
        return !!value;
      }
      return true; // Optional for Workouts
    }),
    frequency: yup
      .string()
      .test('frequency-required', 'Required', function (value) {
        const { parameter } = this.parent;
        if (parameter === 'Workouts') {
          return !!value;
        }
        return true; // Optional for non-Workouts
      }),
    // duration: yup
    //   .string()
    //   .test('duration-required', 'Required', function (value) {
    //     const { parameter } = this.parent;
    //     if (parameter === 'Workouts') {
    //       return !!value;
    //     }
    //     return true; // Optional for non-Workouts
    //   }),
    // duration_unit: yup
    //   .string()
    //   .test('duration-unit-required', 'Required', function (value) {
    //     const { parameter } = this.parent;
    //     if (parameter === 'Workouts') {
    //       return !!value;
    //     }
    //     return true; // Optional for non-Workouts
    //   }),
    // shift: yup.string().test('shift-required', 'Required', function (value) {
    //   const { parameter } = this.parent;
    //   if (parameter === 'Workouts') {
    //     return !!value;
    //   }
    //   return true; // Optional for non-Workouts
    // }),
    count_by: yup
      .string()
      .test('count-by-required', 'Required', function (value) {
        const { parameter } = this.parent;
        if (parameter === 'Workouts') {
          return !!value;
        }
        return true; // Optional for non-Workouts
      }),
  })
);

export default function AddBadges() {
  const checkUserRole = new getUserRole();
  const navigate = useNavigate();
  const urlParams = useParams();
  const [loading, setLoading] = useState(false);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [showBackClickDialogue, setShowBackClickDialogue] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const titleCharLimit = 60;
  const descriptionCharLimit = 400;
  const isViewOnly = window.location.pathname.includes('/view') ? true : false;
  const [originalBadgeContent, setOriginalBadgeContent] = useState(null);
  const [originalFilters, setOriginalFilters] = useState(null);
  const [badgesContent, setBadgesContent] = useState({
    id: null,
    name: {
      de: { name: '' },
      en: { name: '' },
      fr: { name: '' },
    },
    description: {
      de: { description: '' },
      en: { description: '' },
      fr: { description: '' },
    },
    locked_image: null,
    thumbnail: null,
    sequence: '',
    category: null,
  });

  const [categoryOptions, setCategoryOptions] = useState([]);

  const [filters, setFilters] = useState([
    {
      andOr: '',
      parameter: '',
      operator: '',
      value: '',
      unit: '',
      frequency: '',
      duration: '',
      duration_unit: '',
      shift: '',
      count_by: '',
      count_by_device: '',
    },
  ]);
  const [filterErrors, setFilterErrors] = useState([
    {
      andOr: null,
      parameter: null,
      operator: null,
      value: null,
      unit: null,
      frequency: null,
      duration: null,
      duration_unit: null,
      shift: null,
      count_by: null,
      count_by_device: null,
    },
  ]);

  const unitOptions = {
    Distance: [
      { value: 'km', label: 'Km' },
      { value: 'miles', label: 'Miles' },
    ],
    Time: [
      { value: 'hours', label: 'Hours' },
      { value: 'mins', label: 'Minutes' },
    ],
    Workouts: [{ value: 'count', label: 'Count' }],
  };

  const handleAddFilter = () => {
    const firstParameter = filters[0]?.parameter;
    if (firstParameter === 'Workouts') {
      Toast.error('Cannot add additional parameters when Workouts is selected');
      return;
    }
    
    if (filters.length >= 2) {
      Toast.error('Maximum 2 parameters allowed');
      return;
    }
    
    setFilters([
      ...filters,
      {
        andOr: '',
        parameter: '',
        operator: '',
        value: '',
        unit: '',
        frequency: '',
        duration: '',
        duration_unit: '',
        shift: '',
        count_by: '',
        count_by_device: '',
      },
    ]);
    setFilterErrors([
      ...filterErrors,
      {
        andOr: null,
        parameter: null,
        operator: null,
        value: null,
        unit: null,
        frequency: null,
        duration: null,
        duration_unit: null,
        shift: null,
        count_by: null,
        count_by_device: null,
      },
    ]);
  };

  const handleRemoveFilter = (idx) => {
    setFilters(filters.filter((_, i) => i !== idx));
    setFilterErrors(filterErrors.filter((_, i) => i !== idx));
  };

  const getAvailableParameterOptions = (currentIndex) => {
    const firstParameter = filters[0]?.parameter;
    const secondParameter = filters[1]?.parameter;
    
    if (currentIndex === 0) {
      if (secondParameter === 'Time') {
        return ENUMS.PARAMETER_OPTIONS.filter(opt => opt.value === 'Distance' || opt.value === 'Workouts');
      } else if (secondParameter === 'Distance') {
        return ENUMS.PARAMETER_OPTIONS.filter(opt => opt.value === 'Time' || opt.value === 'Workouts');
      }
      return ENUMS.PARAMETER_OPTIONS;
    }
    
    if (currentIndex === 1) {
      if (firstParameter === 'Distance') {
        return ENUMS.PARAMETER_OPTIONS.filter(opt => opt.value === 'Time' || opt.value === 'Workouts');
      } else if (firstParameter === 'Time') {
        return ENUMS.PARAMETER_OPTIONS.filter(opt => opt.value === 'Distance' || opt.value === 'Workouts');
      } else if (firstParameter === 'Workouts') {
        return [];
      }
    }
    
    return ENUMS.PARAMETER_OPTIONS;
  };

  const handleFilterChange = (idx, field, value) => {
    let updatedFilters = filters.map((f, i) =>
      i === idx
        ? {
            ...f,
            [field]: value,
            ...(field === 'parameter' ? { unit: '', value: '' } : {}),
          }
        : f
    );


    if (field === 'parameter') {
      const originalFilter = originalFilters?.find(f => f.parameter === value);
      
      if (originalFilter) {
        updatedFilters[idx] = {
          ...updatedFilters[idx],
          ...originalFilter,
          andOr: idx > 0 ? (originalFilter.andOr || 'AND') : '',
        };
      }
      
      if (idx === 1 && (value === 'Distance' || value === 'Time') && 
          (updatedFilters[0]?.parameter === 'Distance' || updatedFilters[0]?.parameter === 'Time')) {
        updatedFilters[idx] = {
          ...updatedFilters[idx],
          count_by_device: updatedFilters[0].count_by_device || '',
        };
      }
      
      if (idx === 0) {
        if (value === 'Workouts' && updatedFilters.length > 1) {
          updatedFilters = [updatedFilters[0]];
          setFilterErrors([filterErrors[0]]);
        }
        else if (value === 'Distance' && updatedFilters[1]?.parameter === 'Distance') {
          updatedFilters[1] = {
            ...updatedFilters[1],
            parameter: '',
            operator: '',
            value: '',
            unit: '',
          };
        }
        else if (value === 'Time' && updatedFilters[1]?.parameter === 'Time') {
          updatedFilters[1] = {
            ...updatedFilters[1],
            parameter: '',
            operator: '',
            value: '',
            unit: '',
          };
        }
      }
      else if (idx === 1) {
        if (value === 'Workouts') {
          updatedFilters = [
            {
              andOr: '',
              parameter: 'Workouts',
              operator: '',
              value: updatedFilters[1].value || '',
              unit: '',
              frequency: updatedFilters[1].frequency || '',
              duration: updatedFilters[1].duration || '',
              duration_unit: updatedFilters[1].duration_unit || '',
              shift: updatedFilters[1].shift || '',
              count_by: updatedFilters[1].count_by || '',
              count_by_device: '',
            }
          ];
          setFilterErrors([{
            andOr: null,
            parameter: null,
            operator: null,
            value: null,
            unit: null,
            frequency: null,
            duration: null,
            duration_unit: null,
            shift: null,
            count_by: null,
            count_by_device: null,
          }]);
        }
        // If second becomes same as first, clear it
        else if (value === updatedFilters[0]?.parameter) {
          updatedFilters[1] = {
            ...updatedFilters[1],
            parameter: '',
            operator: '',
            value: '',
            unit: '',
          };
        }
      }
    }

    if (field === 'count_by_device' && (filters[idx].parameter === 'Distance' || filters[idx].parameter === 'Time')) {
      updatedFilters = updatedFilters.map((f, i) => {
        if (i !== idx && (f.parameter === 'Distance' || f.parameter === 'Time')) {
          return {
            ...f,
            count_by_device: value,
          };
        }
        return f;
      });
    }

    setFilters(updatedFilters);
    
    const shouldSkipErrorUpdate = 
      (field === 'parameter' && idx === 0 && value === 'Workouts') ||
      (field === 'parameter' && idx === 1 && value === 'Workouts');
    
    if (!shouldSkipErrorUpdate) {
      setFilterErrors(
        filterErrors.map((err, i) =>
          i === idx ? { ...err, [field]: null } : err
        )
      );
    }
  };

  const imageFileUploadInputRefs = {
    lockedImageInputRef: useRef(),
    unlockedImageInputRef: useRef(),
  };

  const textareaRefs = {
    deDescription: useRef(),
    enDescription: useRef(),
    frDescription: useRef(),
  };

  const textfieldRefs = {
    deTitle: useRef(),
    enTitle: useRef(),
    frTitle: useRef(),
  };

  const handleImageBoxClick = (fileInputRef) => {
    fileInputRef.current.click();
  };

  const handleLanguageContentError = (propertyName, errorMessage = null) => {
    setFieldErrors((prev) => ({
      ...prev,
      [propertyName]: errorMessage,
    }));
  };

  const handleFileSelect = (event) => {
    setIsDataChanged(true);
    const file = event.target.files[0];
    const isLockedImage = event.target.id === 'locked_image_upload';

    if (file && isValidFileType(file)) {
      if (file.size > 2 * 1024 * 1024) {
        const error_message = {
          error: true,
          msg: ENUMS.COMMON_MSG.INVALID_IMAGE_SIZE,
        };
        handleLanguageContentError(
          isLockedImage ? 'locked_image' : 'thumbnail',
          error_message
        );
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result;
        setBadgesContent({
          ...badgesContent,
          [isLockedImage ? 'locked_image' : 'thumbnail']: base64,
        });
        handleLanguageContentError(
          isLockedImage ? 'locked_image' : 'thumbnail',
          null
        );
      };
      reader.readAsDataURL(file);
      event.target.value = null;
    } else if (file && !isValidFileType(file)) {
      const error_message = {
        error: true,
        msg: ENUMS.COMMON_MSG.INVALID_IMAGE_FILE_FORMAT,
      };
      handleLanguageContentError(
        isLockedImage ? 'locked_image' : 'thumbnail',
        error_message
      );
    }
  };

  const clearImage = (type) => {
    setBadgesContent({
      ...badgesContent,
      [type]: null,
    });
  };

  const CardTitle = () => {
    return (
      <>
        <IconButton
          size='small'
          onClick={() => {
            if (isViewOnly) {
              setIsDataChanged(false);
              navigate('/badges');
            } else if (isDataChanged) {
              setShowBackClickDialogue(true);
            } else {
              setIsDataChanged(false);
              navigate('/badges');
            }
          }}
        >
          <ArrowBack />
        </IconButton>
        <Typography
          component='span'
          display='inline-flex'
          alignItems='center'
          fontWeight='600'
        >
          {!_.isEmpty(urlParams) && urlParams.id !== 0
            ? isViewOnly
              ? 'View Badges'
              : 'Edit Badges'
            : 'Add Badges'}
        </Typography>
      </>
    );
  };

  const setIsChangesMade = (isFileChanged = false) => {
    if (badgesContent.id && originalBadgeContent) {
      const updatedKeyValues = _.omitBy(badgesContent, (value, key) =>
        _.isEqual(value, originalBadgeContent[key])
      );
      setIsDataChanged(!isEmpty(updatedKeyValues) || isFileChanged);
    } else {
      setIsDataChanged(true);
    }
  };

  const handleInputChange = (field, name, value) => {
    setIsChangesMade();
    if (field === 'name' && field === 'description') {
      setBadgesContent({ ...badgesContent, [name]: value });
    } else if (field === 'name' && value.length <= titleCharLimit) {
      const [field, lang, propName] = name.split('.');
      setBadgesContent({
        ...badgesContent,
        [field]: {
          ...badgesContent[field],
          [lang]: {
            ...badgesContent[field][lang],
            [propName]: value,
          },
        },
      });
    } else if (
      field === 'description' &&
      value.length <= descriptionCharLimit
    ) {
      const [field, lang, propName] = name.split('.');
      setBadgesContent({
        ...badgesContent,
        [field]: {
          ...badgesContent[field],
          [lang]: {
            ...badgesContent[field][lang],
            [propName]: value,
          },
        },
      });
    }
  };

  const checkContentValidation = async () => {
    let isValid = null;
    const titleSchema = yup.object().shape({
      name: yup.string().required(ENUMS.COMMON_MSG.BLANK_FIELD_NOTALLOW),
    });
    const descriptionSchema = yup.object().shape({
      description: yup.string().required(ENUMS.COMMON_MSG.BLANK_FIELD_NOTALLOW),
    });
    const schema = yup.object().shape({
      name: yup.object().shape({
        en: titleSchema,
        de: titleSchema,
        fr: titleSchema,
      }),
      description: yup.object().shape({
        en: descriptionSchema,
        de: descriptionSchema,
        fr: descriptionSchema,
      }),
      sequence: yup
        .number()
        .typeError('Sequence number is required')
        .required('Sequence number is required')
        .integer('Sequence number must be an integer')
        .min(1, 'Sequence number must be at least 1'),
      category: yup
        .number()
        .typeError('Category is required')
        .required('Category is required'),
    });
    isValid = await validateSchema(badgesContent, schema);
    setFieldErrors(isValid);

    let filterValid = true;
    let newFilterErrors = [];
    try {
      await filterSchema.validate(filters, {
        abortEarly: false,
        context: { hasMultiple: filters.length > 1 },
      });
      newFilterErrors = filters.map(() => ({}));
    } catch (err) {
      filterValid = false;
      newFilterErrors = filters.map(() => ({}));
      if (err.inner && Array.isArray(err.inner)) {
        err.inner.forEach((validationError) => {
          const { path, message } = validationError;
          const match = path.match(/\[(\d+)\]\.(\w+)/);
          if (match) {
            const idx = parseInt(match[1], 10);
            const field = match[2];
            newFilterErrors[idx][field] = message;
          }
        });
      }
      setFilterErrors(newFilterErrors);
    }

    return isValid === true && filterValid;
  };

  const handleSaveOrReviewBtnClick = async (e, isReview = false) => {
    e.preventDefault();
    const isContentValid = await checkContentValidation();
    if (isContentValid !== true) return;
    setLoading(true);

    let rule_type_distance = false;
    let rule_type_time = false;
    let rule_type_workouts = false;
    let targeted_distance = null;
    let targeted_time = null;
    let no_of_workouts = null; // Changed from targeted_workouts
    let distance_op = '';
    let time_op = '';
    let workouts_op = '';
    let conditional_op = null;
    let unit_distance = null;
    let unit_time = null;
    let unit_workouts = null;
    let frequency = null;
    let duration = null;
    let duration_unit = null;
    let shift = null;
    let count_by = null;
    let count_by_device = null;

    filters.forEach((filter, idx) => {
      if (filter.parameter === 'Distance') {
        rule_type_distance = true;
        targeted_distance = filter.value;
        distance_op = filter.operator;
        unit_distance = filter.unit;
        count_by_device = filter.count_by_device || null;
        frequency = 'default';
      }
      if (filter.parameter === 'Time') {
        rule_type_time = true;
        targeted_time = filter.value;
        time_op = filter.operator;
        unit_time = filter.unit;
        count_by_device = filter.count_by_device || null;
        frequency = 'default';
      }
      if (filter.parameter === 'Workouts') {
        rule_type_workouts = true;
        no_of_workouts = filter.value ? parseFloat(filter.value) : null; // Convert to number or null if empty
        frequency = filter.frequency || null; // Set to null if empty
        duration = filter.duration ? parseFloat(filter.duration) : null; // Convert to number or null if empty
        duration_unit = filter.duration_unit || null; // Set to null if empty
        shift = filter.shift || null; // Set to null if empty
        count_by = filter.count_by || null; // Set to null if empty
      }
      if (idx === 1) {
        conditional_op = filter.andOr;
      }
    });

    if (unit_distance === 'miles' && targeted_distance) {
      targeted_distance = ENUMS.convertToBaseUnit(targeted_distance, 'miles');
      unit_distance = 'km';
    }
    if (unit_time === 'hours' && targeted_time) {
      targeted_time = ENUMS.convertToBaseUnit(targeted_time, 'hours');
      unit_time = 'mins';
    }

    const description = {
      title: {
        en: badgesContent.name?.en?.name || '',
        de: badgesContent.name?.de?.name || '',
        fr: badgesContent.name?.fr?.name || '',
      },
      description: {
        en: badgesContent.description?.en?.description || '',
        de: badgesContent.description?.de?.description || '',
        fr: badgesContent.description?.fr?.description || '',
      },
    };

    const locked_image_upload = badgesContent.locked_image || null;
    const images = badgesContent.thumbnail || null;
    const sequence = badgesContent.sequence;
    const status = isReview ? 'pending' : 'draft';

    let payload = {};
    let hasChanges = false;
    if (badgesContent.id && originalBadgeContent) {
      const originalDescription = {
        title: originalBadgeContent.name,
        description: originalBadgeContent.description,
      };
      if (!_.isEqual(description, originalDescription)) {
        payload.description = description;
        hasChanges = true;
      }
      if (
        !_.isEqual(
          badgesContent.locked_image,
          originalBadgeContent.locked_image
        )
      ) {
        payload.locked_image_upload = locked_image_upload;
        hasChanges = true;
      }
      if (!_.isEqual(badgesContent.thumbnail, originalBadgeContent.thumbnail)) {
        payload.images = images;
        hasChanges = true;
      }
      if (!_.isEqual(filters, originalFilters)) {
        payload.rule_type_distance = rule_type_distance;
        payload.rule_type_time = rule_type_time;
        payload.rule_type_workouts = rule_type_workouts;
        payload.targeted_distance = targeted_distance;
        payload.targeted_time = targeted_time;
        payload.no_of_workouts = no_of_workouts; // Changed from targeted_workouts
        payload.distance_op = distance_op;
        payload.time_op = time_op;
        payload.workouts_op = workouts_op;
        payload.conditional_op = conditional_op;
        payload.unit_distance = unit_distance;
        payload.unit_time = unit_time;
        payload.unit_workouts = unit_workouts;
        payload.frequency = frequency;
        payload.duration = duration;
        payload.duration_unit = duration_unit;
        payload.shift = shift;
        payload.count_by = count_by;
        payload.count_by_device = count_by_device;
        hasChanges = true;
      }
      if (badgesContent.sequence !== (originalBadgeContent?.sequence || '')) {
        payload.sequence = sequence;
        hasChanges = true;
      }
      if (
        !_.isEqual(badgesContent.category, originalBadgeContent?.category)
      ) {
        payload.category = badgesContent.category;
        hasChanges = true;
      }
      if (hasChanges) {
        payload.status = status;
      }
    } else {
      payload = {
        rule_type_distance,
        rule_type_time,
        rule_type_workouts,
        targeted_distance,
        targeted_time,
        no_of_workouts, // Changed from targeted_workouts
        distance_op,
        time_op,
        workouts_op,
        conditional_op,
        unit_distance,
        unit_time,
        unit_workouts,
        frequency,
        duration,
        duration_unit,
        shift,
        count_by,
        count_by_device,
        description,
        locked_image_upload,
        images,
        status,
        sequence,
        category: badgesContent.category,
      };
    }

    try {
      let response;
      if (badgesContent.id) {
        response = await updateBadge(badgesContent.id, payload);
      } else {
        response = await addBadge(payload);
      }
      setLoading(false);
      if (response && response.data && response.data.status) {
        const successMsg = response.data.detail || 'Badge saved successfully';
        if (isReview && (checkUserRole.isAdmin() || checkUserRole.isStaff())) {
          setIsDataChanged(false);
          Toast.success(successMsg);
          setTimeout(() => navigate('/badges'), 1200);
        } else if (checkUserRole.isStaff() && !isReview && response.data.data) {
          setIsDataChanged(false);
          Toast.success(successMsg);
        } else {
          Toast.success(successMsg);
          setTimeout(() => navigate('/badges'), 1200);
        }
      } else {
        Toast.error(
          (response && response.data && response.data.detail) ||
            'Failed to save badge'
        );
      }
    } catch (error) {
      setLoading(false);
      Toast.error(error?.error_message || 'Failed to save badge');
    }
  };

  useEffect(() => {
    if (urlParams && urlParams.id) {
      setLoading(true);
      getBadgeById(urlParams.id).then((res) => {
        if (res && res.data && res.data.id) {
          setFormFromApi(res.data);
        }
        setLoading(false);
      });
    }
  }, [urlParams]);

  function setFormFromApi(apiData) {
    setBadgesContent({
      id: apiData.id,
      name: {
        en: { name: apiData.description?.title?.en || '' },
        de: { name: apiData.description?.title?.de || '' },
        fr: { name: apiData.description?.title?.fr || '' },
      },
      description: {
        en: { description: apiData.description?.description?.en || '' },
        de: { description: apiData.description?.description?.de || '' },
        fr: { description: apiData.description?.description?.fr || '' },
      },
      locked_image: apiData.locked_image || null,
      thumbnail: apiData.image || null,
      sequence: apiData.sequence || '',
      category: apiData.category || null,
    });
    setOriginalBadgeContent({
      id: apiData.id,
      name: {
        en: { name: apiData.description?.title?.en || '' },
        de: { name: apiData.description?.title?.de || '' },
        fr: { name: apiData.description?.title?.fr || '' },
      },
      description: {
        en: { description: apiData.description?.description?.en || '' },
        de: { description: apiData.description?.description?.de || '' },
        fr: { description: apiData.description?.description?.fr || '' },
      },
      locked_image: apiData.locked_image || null,
      thumbnail: apiData.image || null,
      category: apiData.category || null,
    });
    const filters = [];
    if (apiData.rule_type_distance) {
      filters.push({
        andOr: '',
        parameter: 'Distance',
        operator: apiData.distance_op || '',
        value: apiData.targeted_distance !== null && apiData.targeted_distance !== undefined ? String(apiData.targeted_distance) : '',
        unit: apiData.unit_distance || '',
        frequency: '',
        duration: '',
        duration_unit: '',
        shift: '',
        count_by: '',
        count_by_device: apiData.count_by_device || '',
      });
    }
    if (apiData.rule_type_time) {
      filters.push({
        andOr: filters.length > 0 ? (apiData.conditional_op || 'AND') : '',
        parameter: 'Time',
        operator: apiData.time_op || '',
        value: apiData.targeted_time !== null && apiData.targeted_time !== undefined ? String(apiData.targeted_time) : '',
        unit: apiData.unit_time || '',
        frequency: '',
        duration: '',
        duration_unit: '',
        shift: '',
        count_by: '',
        count_by_device: apiData.count_by_device || '',
      });
    }
    if (apiData.frequency && apiData.frequency !== 'default') {
      filters.push({
        andOr: filters.length > 0 ? (apiData.conditional_op || 'AND') : '',
        parameter: 'Workouts',
        // operator: apiData.workouts_op || '',
        value: apiData.no_of_workouts !== null && apiData.no_of_workouts !== undefined ? String(apiData.no_of_workouts) : '',
        // unit: apiData.unit_workouts || '',
        frequency: apiData.frequency || '',
        duration: apiData.duration !== null && apiData.duration !== undefined ? String(apiData.duration) : '',
        duration_unit: apiData.duration_unit || '',
        shift: apiData.shift || '',
        count_by: apiData.count_by || '',
        count_by_device: '',
      });
    }
    setFilters(
      filters.length
        ? filters
        : [
            {
              andOr: '',
              parameter: '',
              operator: '',
              value: '',
              unit: '',
              frequency: '',
              duration: '',
              duration_unit: '',
              shift: '',
              count_by: '',
              count_by_device: '',
            },
          ]
    );
    setFilterErrors(
      filters.map(() => ({
        andOr: null,
        parameter: null,
        operator: null,
        value: null,
        unit: null,
        frequency: null,
        duration: null,
        duration_unit: null,
        shift: null,
        count_by: null,
        count_by_device: null,
      }))
    );
    setOriginalFilters(
      filters.length ? JSON.parse(JSON.stringify(filters)) : null
    );
  }

  useEffect(() => {
    setIsChangesMade();
  }, [badgesContent]);

  useEffect(() => {
    getBadgesCategory().then((res) => {
      if (res && res.data) {
        const categories = res.data.map((cat) => ({
          value: cat.id,
          label: cat.name,
          fullData: cat, 
        }));
        setCategoryOptions(categories);
      }
    });
  }, []);

  return (
    <Layout>
      <RingSpinnerOverlay
        loading={loading}
        overlayColor='rgba(0,0,0,0.2)'
        size={50}
        color='#2d38384d'
        borderWidth={3}
      />
      <Container component='div' maxWidth='xl' className='plr-0'>
        <Card component='div' sx={ENUMS.COMMON_STYLE.cardStyle}>
          <CardHeader title={<CardTitle />} className='template-cardheader' />
          <CardContent className='template-card-content-scroll theme-scroll-bar'>
            <Card
              component='div'
              sx={ENUMS.COMMON_STYLE.innerCardStyle}
              style={{ overflow: 'visible' }}
            >
              <CardHeader
                title='General Details'
                className='template-sub-cardheader'
              />
              <CardContent sx={{ pt: 1 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6} md={6}>
                    <MinimalTextField
                      placeholder='Sequence Number'
                      type='number'
                      value={badgesContent.sequence}
                      onChange={(e) => {
                        setBadgesContent({
                          ...badgesContent,
                          sequence: e.target.value.replace(/[^0-9]/g, ''),
                        });
                        setIsChangesMade();
                      }}
                      error={!!fieldErrors.sequence}
                      helperText={fieldErrors.sequence?.msg}
                      disabled={isViewOnly}
                      inputProps={{ min: 1 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box sx={{ mt: 2}}>
                      <MinimalSingleSelect
                        value={categoryOptions.find(
                          (opt) => opt.value === badgesContent.category
                        )}
                        sx={{padding:'4px 14px'}}
                        options={categoryOptions}
                        placeholder='Select Category'
                        onInputChange={(opt) => {
                          setBadgesContent({
                            ...badgesContent,
                            category: opt.value,
                          });
                          setIsChangesMade();
                        }}
                        error={!!fieldErrors.category}
                        disabled={isViewOnly}
                      />
                      {fieldErrors.category && (
                        <FormHelperText error>
                          {fieldErrors.category?.msg}
                        </FormHelperText>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <BadgesLanguageContentCard
              language='German'
              shortLanguage='de'
              badgesContent={badgesContent}
              handleInputChange={handleInputChange}
              fieldErrors={fieldErrors}
              setFieldErrors={setFieldErrors}
              textfieldRefs={textfieldRefs}
              textareaRefs={textareaRefs}
              titleCharLimit={titleCharLimit}
              descriptionCharLimit={descriptionCharLimit}
              isViewOnly={isViewOnly}
            />
            <BadgesLanguageContentCard
              language='English'
              shortLanguage='en'
              badgesContent={badgesContent}
              handleInputChange={handleInputChange}
              fieldErrors={fieldErrors}
              setFieldErrors={setFieldErrors}
              textfieldRefs={textfieldRefs}
              textareaRefs={textareaRefs}
              titleCharLimit={titleCharLimit}
              descriptionCharLimit={descriptionCharLimit}
              isViewOnly={isViewOnly}
            />
            <BadgesLanguageContentCard
              language='French'
              shortLanguage='fr'
              badgesContent={badgesContent}
              handleInputChange={handleInputChange}
              fieldErrors={fieldErrors}
              setFieldErrors={setFieldErrors}
              textfieldRefs={textfieldRefs}
              textareaRefs={textareaRefs}
              titleCharLimit={titleCharLimit}
              descriptionCharLimit={descriptionCharLimit}
              isViewOnly={isViewOnly}
            />
            <div className='mb-20'>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ mt: '16px' }}>
                  <Box elevation={3} style={{ height: '170px' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <Box
                          elevation={3}
                          className='dashed-border no-record-box'
                          sx={{ height: '150px', padding: '10px' }}
                          onClick={() => {
                            if (
                              !isViewOnly &&
                              isEmpty(badgesContent.locked_image)
                            )
                              handleImageBoxClick(
                                imageFileUploadInputRefs.lockedImageInputRef
                              );
                          }}
                        >
                          <input
                            ref={imageFileUploadInputRefs.lockedImageInputRef}
                            type='file'
                            accept='image/*'
                            style={{ display: 'none' }}
                            onChange={handleFileSelect}
                            id='locked_image_upload'
                          />
                          {isEmpty(badgesContent.locked_image) && (
                            <>
                              <CloudUpload
                                sx={{
                                  fontSize: '55px',
                                  color: ENUMS.THEME.MAIN_COLOR,
                                }}
                              />
                              <Typography component='p'>
                                Upload Locked Badges
                              </Typography>
                            </>
                          )}
                          {!isEmpty(badgesContent.locked_image) && (
                            <img
                              src={badgesContent.locked_image}
                              alt='locked badge img'
                            />
                          )}
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <div>
                          <FloatingButton
                            baseClassName='common-btn'
                            text='Clear'
                            onClick={() => {
                              if (!isViewOnly) clearImage('locked_image');
                            }}
                            sx={{ mb: 2 }}
                            disabled={
                              isViewOnly || isEmpty(badgesContent.locked_image)
                            }
                          />
                          <FloatingButton
                            baseClassName='common-btn'
                            text='Browse'
                            onClick={() => {
                              if (!isViewOnly)
                                handleImageBoxClick(
                                  imageFileUploadInputRefs.lockedImageInputRef
                                );
                            }}
                            disabled={isViewOnly}
                          />
                        </div>
                      </Grid>
                    </Grid>
                    <FormHelperText
                      error={
                        fieldErrors.locked_image &&
                        fieldErrors.locked_image.error
                      }
                    >
                      {fieldErrors.locked_image && fieldErrors.locked_image.msg}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid item xs={6} sx={{ mt: '16px' }}>
                  <Box elevation={3} style={{ height: '170px' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <Box
                          elevation={3}
                          className='dashed-border no-record-box'
                          sx={{ height: '150px', padding: '10px' }}
                          onClick={() => {
                            if (!isViewOnly && isEmpty(badgesContent.thumbnail))
                              handleImageBoxClick(
                                imageFileUploadInputRefs.unlockedImageInputRef
                              );
                          }}
                        >
                          <input
                            ref={imageFileUploadInputRefs.unlockedImageInputRef}
                            type='file'
                            accept='image/*'
                            style={{ display: 'none' }}
                            onChange={handleFileSelect}
                            id='image'
                          />
                          {isEmpty(badgesContent.thumbnail) && (
                            <>
                              <CloudUpload
                                sx={{
                                  fontSize: '55px',
                                  color: ENUMS.THEME.MAIN_COLOR,
                                }}
                              />
                              <Typography component='p'>
                                Upload Unlocked Badges
                              </Typography>
                            </>
                          )}
                          {!isEmpty(badgesContent.thumbnail) && (
                            <img
                              src={badgesContent.thumbnail}
                              alt='unlocked badge img'
                            />
                          )}
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <div>
                          <FloatingButton
                            baseClassName='common-btn'
                            text='Clear'
                            onClick={() => {
                              if (!isViewOnly) clearImage('thumbnail');
                            }}
                            sx={{ mb: 2 }}
                            disabled={
                              isViewOnly || isEmpty(badgesContent.thumbnail)
                            }
                          />
                          <FloatingButton
                            baseClassName='common-btn'
                            text='Browse'
                            onClick={() => {
                              if (!isViewOnly)
                                handleImageBoxClick(
                                  imageFileUploadInputRefs.unlockedImageInputRef
                                );
                            }}
                            disabled={isViewOnly}
                          />
                        </div>
                      </Grid>
                    </Grid>
                    <FormHelperText
                      error={
                        fieldErrors.thumbnail && fieldErrors.thumbnail.error
                      }
                    >
                      {fieldErrors.thumbnail && fieldErrors.thumbnail.msg}
                    </FormHelperText>
                  </Box>
                </Grid>
              </Grid>
            </div>
            <div style={{ marginTop: 50 }}>
              <Box
                sx={{
                  overflow: 'visible',
                  background: '#fff',
                  borderRadius: 2,
                  border: '1px solid #e0e0e0',
                  p: 0,
                }}
              >
                <Table size='small'>
                  <TableHead>
                    <TableRow style={{ height: 48 }}>
                      <TableCell
                        style={{
                          width: 60,
                          padding: '0 7px',
                          textAlign: 'left',
                          fontWeight: 600,
                          color: '#222',
                          background: '#fafbfc',
                          borderBottom: '1px solid #e0e0e0',
                        }}
                      />
                      <TableCell
                        style={{
                          padding: '0 7px',
                          textAlign: 'left',
                          fontWeight: 600,
                          color: '#222',
                          background: '#fafbfc',
                          borderBottom: '1px solid #e0e0e0',
                        }}
                      >
                        And/or
                      </TableCell>
                      <TableCell
                        style={{
                          padding: '0 7px',
                          textAlign: 'left',
                          fontWeight: 600,
                          color: '#222',
                          background: '#fafbfc',
                          borderBottom: '1px solid #e0e0e0',
                        }}
                      >
                        Parameters
                      </TableCell>
                      {!filters.some((f) => f.parameter === 'Workouts') && (
                        <TableCell
                          style={{
                            padding: '0 7px',
                            textAlign: 'left',
                            fontWeight: 600,
                            color: '#222',
                            background: '#fafbfc',
                            borderBottom: '1px solid #e0e0e0',
                          }}
                        >
                          Operator
                        </TableCell>
                      )}
                      <TableCell
                        style={{
                          padding: '0 7px',
                          textAlign: 'left',
                          fontWeight: 600,
                          color: '#222',
                          background: '#fafbfc',
                          borderBottom: '1px solid #e0e0e0',
                        }}
                      >
                        {filters.some((f) => f.parameter === 'Workouts')
                          ? 'Number of Workouts'
                          : 'Time & Distance'}
                      </TableCell>
                      {!filters.some((f) => f.parameter === 'Workouts') && (
                        <>
                          <TableCell
                            style={{
                              padding: '0 7px',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#222',
                              background: '#fafbfc',
                              borderBottom: '1px solid #e0e0e0',
                            }}
                          >
                            Unit
                          </TableCell>
                          <TableCell
                            style={{
                              padding: '0 7px',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#222',
                              background: '#fafbfc',
                              borderBottom: '1px solid #e0e0e0',
                            }}
                          >
                            Count by Device
                          </TableCell>
                        </>
                      )}

                      {filters.some((f) => f.parameter === 'Workouts') && (
                        <>
                          <TableCell
                            style={{
                              padding: '0 7px',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#222',
                              background: '#fafbfc',
                              borderBottom: '1px solid #e0e0e0',
                            }}
                          >
                            Frequency
                          </TableCell>
                          <TableCell
                            style={{
                              padding: '0 7px',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#222',
                              background: '#fafbfc',
                              borderBottom: '1px solid #e0e0e0',
                            }}
                          >
                            Duration
                          </TableCell>
                          <TableCell
                            style={{
                              padding: '0 7px',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#222',
                              background: '#fafbfc',
                              borderBottom: '1px solid #e0e0e0',
                            }}
                          >
                            Duration Unit
                          </TableCell>
                          <TableCell
                            style={{
                              padding: '0 7px',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#222',
                              background: '#fafbfc',
                              borderBottom: '1px solid #e0e0e0',
                            }}
                          >
                            Shift
                          </TableCell>
                          <TableCell
                            style={{
                              padding: '0 7px',
                              textAlign: 'left',
                              fontWeight: 600,
                              color: '#222',
                              background: '#fafbfc',
                              borderBottom: '1px solid #e0e0e0',
                            }}
                          >
                            Count By
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filters.map((filter, idx) => (
                      <TableRow key={idx} style={{ height: 48 }}>
                        <TableCell
                          style={{
                            padding: '0 8px',
                            verticalAlign: 'middle',
                            minWidth: 60,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <IconButton
                              size='small'
                              onClick={handleAddFilter}
                              disabled={
                                isViewOnly ||
                                filters.length >= 2 ||
                                filters[0]?.parameter === 'Workouts'
                              }
                            >
                              <AddIcon />
                            </IconButton>
                            <IconButton
                              size='small'
                              onClick={() => handleRemoveFilter(idx)}
                              disabled={filters.length === 1 || isViewOnly}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '0 8px',
                            verticalAlign: 'top',
                            minWidth: 120,
                          }}
                        >
                          {idx > 0 && (
                            <Box sx={{ width: '100%' }}>
                              <MinimalSingleSelect
                                value={{
                                  value: filter.andOr,
                                  label: filter.andOr,
                                }}
                                options={ENUMS.AND_OR_LIST}
                                placeholder='And/Or'
                                onInputChange={(opt) =>
                                  handleFilterChange(idx, 'andOr', opt.value)
                                }
                                error={
                                  !!(
                                    filterErrors[idx] && filterErrors[idx].andOr
                                  )
                                }
                                style={{ minWidth: 80 }}
                                disabled={isViewOnly}
                              />
                              {filterErrors[idx] && filterErrors[idx].andOr && (
                                <FormHelperText
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].andOr
                                    )
                                  }
                                >
                                  {filterErrors[idx] && filterErrors[idx].andOr}
                                </FormHelperText>
                              )}
                            </Box>
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '0 8px',
                            verticalAlign: 'top',
                            minWidth: 180,
                          }}
                        >
                          <Box sx={{ width: '100%' }}>
                            <MinimalSingleSelect
                              value={getAvailableParameterOptions(idx).find(
                                (opt) => opt.value === filter.parameter
                              )}
                              options={getAvailableParameterOptions(idx)}
                              placeholder='Select Parameter'
                              onInputChange={(opt) =>
                                handleFilterChange(idx, 'parameter', opt.value)
                              }
                              error={
                                !!(
                                  filterErrors[idx] &&
                                  filterErrors[idx].parameter
                                )
                              }
                              style={{ minWidth: 160 }}
                              disabled={isViewOnly}
                            />
                            {filterErrors[idx] &&
                              filterErrors[idx].parameter && (
                                <FormHelperText
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].parameter
                                    )
                                  }
                                >
                                  {filterErrors[idx] &&
                                    filterErrors[idx].parameter}
                                </FormHelperText>
                              )}
                          </Box>
                        </TableCell>
                        {filter.parameter !== 'Workouts' && (
                          <TableCell
                            style={{
                              padding: '0 8px',
                              verticalAlign: 'top',
                              minWidth: 180,
                            }}
                          >
                            <Box sx={{ width: '100%' }}>
                              <MinimalSingleSelect
                                value={ENUMS.OPERATOR_OPTIONS.find(
                                  (opt) => opt.value === filter.operator
                                )}
                                options={ENUMS.OPERATOR_OPTIONS}
                                placeholder='Select Operator'
                                onInputChange={(opt) =>
                                  handleFilterChange(idx, 'operator', opt.value)
                                }
                                error={
                                  !!(
                                    filterErrors[idx] &&
                                    filterErrors[idx].operator
                                  )
                                }
                                style={{ minWidth: 160 }}
                                disabled={isViewOnly}
                              />
                              {filterErrors[idx] &&
                                filterErrors[idx].operator && (
                                  <FormHelperText
                                    error={
                                      !!(
                                        filterErrors[idx] &&
                                        filterErrors[idx].operator
                                      )
                                    }
                                  >
                                    {filterErrors[idx] &&
                                      filterErrors[idx].operator}
                                  </FormHelperText>
                                )}
                            </Box>
                          </TableCell>
                        )}
                        <TableCell
                          style={{
                            padding: '5px 8px',
                            verticalAlign: 'top',
                            minWidth: 200,
                          }}
                        >
                          <Box sx={{ width: '100%' }}>
                            <MinimalTextField
                              value={filter.value}
                              placeholder={
                                filter.parameter === 'Workouts'
                                  ? 'Enter number of workouts'
                                  : filter.parameter === 'Time'
                                  ? 'Enter Time'
                                  : 'Enter Distance'
                              }
                              onChange={(e) =>
                                handleFilterChange(idx, 'value', e.target.value)
                              }
                              error={
                                !!(filterErrors[idx] && filterErrors[idx].value)
                              }
                              style={{ minWidth: 180, margin: 0, padding: 0 }}
                              inputProps={{ style: { padding: '19px 12px' } }}
                              disabled={isViewOnly}
                            />
                            {filterErrors[idx] && filterErrors[idx].value && (
                              <FormHelperText
                                error={
                                  !!(
                                    filterErrors[idx] && filterErrors[idx].value
                                  )
                                }
                              >
                                {filterErrors[idx] && filterErrors[idx].value}
                              </FormHelperText>
                            )}
                          </Box>
                        </TableCell>
                        {filter.parameter !== 'Workouts' && (
                          <>
                            <TableCell
                              style={{
                                padding: '0 8px',
                                verticalAlign: 'top',
                                minWidth: 120,
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <MinimalSingleSelect
                                  value={(
                                    unitOptions[filter.parameter] || []
                                  ).find((opt) => opt.value === filter.unit)}
                                  options={unitOptions[filter.parameter] || []}
                                  placeholder='Select Unit'
                                  onInputChange={(opt) =>
                                    handleFilterChange(idx, 'unit', opt.value)
                                  }
                                  error={
                                    !!(
                                      filterErrors[idx] && filterErrors[idx].unit
                                    )
                                  }
                                  style={{ minWidth: 100 }}
                                  disabled={isViewOnly}
                                />
                                {filterErrors[idx] && filterErrors[idx].unit && (
                                  <FormHelperText
                                    error={
                                      !!(
                                        filterErrors[idx] &&
                                        filterErrors[idx].unit
                                      )
                                    }
                                  >
                                    {filterErrors[idx] && filterErrors[idx].unit}
                                  </FormHelperText>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell
                              style={{
                                padding: '0 8px',
                                verticalAlign: 'top',
                                minWidth: 180,
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <MinimalSingleSelect
                                  value={ENUMS.COUNT_BY_DEVICE_OPTIONS.find(
                                    (opt) => opt.value === filter.count_by_device
                                  )}
                                  options={ENUMS.COUNT_BY_DEVICE_OPTIONS}
                                  placeholder='Select Device'
                                  onInputChange={(opt) =>
                                    handleFilterChange(
                                      idx,
                                      'count_by_device',
                                      opt.value
                                    )
                                  }
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].count_by_device
                                    )
                                  }
                                  style={{ minWidth: 160 }}
                                  disabled={
                                    isViewOnly ||
                                    (idx === 1 && 
                                     (filter.parameter === 'Distance' || filter.parameter === 'Time') &&
                                     (filters[0]?.parameter === 'Distance' || filters[0]?.parameter === 'Time'))
                                  }
                                />
                                {filterErrors[idx] &&
                                  filterErrors[idx].count_by_device && (
                                    <FormHelperText
                                      error={
                                        !!(
                                          filterErrors[idx] &&
                                          filterErrors[idx].count_by_device
                                        )
                                      }
                                    >
                                      {filterErrors[idx] &&
                                        filterErrors[idx].count_by_device}
                                    </FormHelperText>
                                  )}
                              </Box>
                            </TableCell>
                          </>
                        )}

                        {filter.parameter === 'Workouts' && (
                          <>
                            <TableCell
                              style={{
                                padding: '0 8px',
                                verticalAlign: 'top',
                                minWidth: 180,
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <MinimalSingleSelect
                                  value={ENUMS.FREQUENCY_OPTIONS.find(
                                    (opt) => opt.value === filter.frequency
                                  )}
                                  options={ENUMS.FREQUENCY_OPTIONS}
                                  placeholder='Select'
                                  onInputChange={(opt) =>
                                    handleFilterChange(
                                      idx,
                                      'frequency',
                                      opt.value
                                    )
                                  }
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].frequency
                                    )
                                  }
                                  style={{ minWidth: 160 }}
                                  disabled={isViewOnly}
                                />
                                {filterErrors[idx] &&
                                  filterErrors[idx].frequency && (
                                    <FormHelperText
                                      error={
                                        !!(
                                          filterErrors[idx] &&
                                          filterErrors[idx].frequency
                                        )
                                      }
                                    >
                                      {filterErrors[idx] &&
                                        filterErrors[idx].frequency}
                                    </FormHelperText>
                                  )}
                              </Box>
                            </TableCell>
                            <TableCell
                              style={{
                                padding: '5px 8px',
                                verticalAlign: 'top',
                                minWidth: 200,
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <MinimalTextField
                                  value={filter.duration || ''}
                                  placeholder='Enter Duration'
                                  onChange={(e) =>
                                    handleFilterChange(
                                      idx,
                                      'duration',
                                      e.target.value
                                    )
                                  }
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].duration
                                    )
                                  }
                                  style={{
                                    minWidth: 180,
                                    margin: 0,
                                    padding: 0,
                                  }}
                                  inputProps={{
                                    style: { padding: '19px 12px' },
                                  }}
                                  disabled={isViewOnly}
                                />
                                {filterErrors[idx] &&
                                  filterErrors[idx].duration && (
                                    <FormHelperText
                                      error={
                                        !!(
                                          filterErrors[idx] &&
                                          filterErrors[idx].duration
                                        )
                                      }
                                    >
                                      {filterErrors[idx] &&
                                        filterErrors[idx].duration}
                                    </FormHelperText>
                                  )}
                              </Box>
                            </TableCell>
                            <TableCell
                              style={{
                                padding: '0 8px',
                                verticalAlign: 'top',
                                minWidth: 180,
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <MinimalSingleSelect
                                  value={ENUMS.DURATION_UNIT_OPTIONS.find(
                                    (opt) => opt.value === filter.duration_unit
                                  )}
                                  options={ENUMS.DURATION_UNIT_OPTIONS}
                                  placeholder='Select'
                                  onInputChange={(opt) =>
                                    handleFilterChange(
                                      idx,
                                      'duration_unit',
                                      opt.value
                                    )
                                  }
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].duration_unit
                                    )
                                  }
                                  style={{ minWidth: 160 }}
                                  disabled={isViewOnly}
                                />
                                {filterErrors[idx] &&
                                  filterErrors[idx].duration_unit && (
                                    <FormHelperText
                                      error={
                                        !!(
                                          filterErrors[idx] &&
                                          filterErrors[idx].duration_unit
                                        )
                                      }
                                    >
                                      {filterErrors[idx] &&
                                        filterErrors[idx].duration_unit}
                                    </FormHelperText>
                                  )}
                              </Box>
                            </TableCell>
                            <TableCell
                              style={{
                                padding: '5px 8px',
                                verticalAlign: 'top',
                                minWidth: 200,
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <MinimalTextField
                                  value={filter.shift || ''}
                                  placeholder='Enter Shift (e.g. 5:00 PM - 7:00 AM)'
                                  onChange={(e) =>
                                    handleFilterChange(
                                      idx,
                                      'shift',
                                      e.target.value
                                    )
                                  }
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].shift
                                    )
                                  }
                                  style={{
                                    minWidth: 180,
                                    margin: 0,
                                    padding: 0,
                                  }}
                                  inputProps={{
                                    style: { padding: '19px 12px' },
                                  }}
                                  disabled={isViewOnly}
                                />
                                {filterErrors[idx] &&
                                  filterErrors[idx].shift && (
                                    <FormHelperText
                                      error={
                                        !!(
                                          filterErrors[idx] &&
                                          filterErrors[idx].shift
                                        )
                                      }
                                    >
                                      {filterErrors[idx] &&
                                        filterErrors[idx].shift}
                                    </FormHelperText>
                                  )}
                              </Box>
                            </TableCell>
                            <TableCell
                              style={{
                                padding: '0 8px',
                                verticalAlign: 'top',
                                minWidth: 180,
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <MinimalSingleSelect
                                  value={ENUMS.COUNT_BY_OPTIONS.find(
                                    (opt) => opt.value === filter.count_by
                                  )}
                                  options={ENUMS.COUNT_BY_OPTIONS}
                                  placeholder='Count By'
                                  onInputChange={(opt) =>
                                    handleFilterChange(
                                      idx,
                                      'count_by',
                                      opt.value
                                    )
                                  }
                                  error={
                                    !!(
                                      filterErrors[idx] &&
                                      filterErrors[idx].count_by
                                    )
                                  }
                                  style={{ minWidth: 160 }}
                                  disabled={isViewOnly}
                                />
                                {filterErrors[idx] &&
                                  filterErrors[idx].count_by && (
                                    <FormHelperText
                                      error={
                                        !!(
                                          filterErrors[idx] &&
                                          filterErrors[idx].count_by
                                        )
                                      }
                                    >
                                      {filterErrors[idx] &&
                                        filterErrors[idx].count_by}
                                    </FormHelperText>
                                  )}
                              </Box>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </div>
          </CardContent>
          <Divider sx={ENUMS.COMMON_STYLE.dividerStyle} />
          <CardActions
            className='template-cardfooter'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Box>
              {checkUserRole.isStaff() && !isViewOnly && (
                <FloatingButton
                  text='Send for Review'
                  baseClassName='common-btn'
                  onClick={(e) => handleSaveOrReviewBtnClick(e, true)}
                  sx={{ mr: 1 }}
                />
              )}
              {!isViewOnly && (
                <FloatingButton
                  text='Save'
                  baseClassName='common-btn'
                  onClick={(e) => handleSaveOrReviewBtnClick(e)}
                />
              )}
            </Box>
          </CardActions>
        </Card>
      </Container>
      <DialogPrompt
        open={showBackClickDialogue}
        onCancel={() => setShowBackClickDialogue(false)}
        onConfirm={() => {
          navigate(ENUMS.ROUTES.BADGES.LIST);
        }}
        title='Clicking on the back, will discard your changes'
      />
    </Layout>
  );
}
